import api from '../../plugins/api'


export enum StatusAprovacao {
    APROVADO = 'Aprovado',
    APROVADO_COM_RESSALVA = 'Aprovado com ressalva',
    REPROVADO = 'Reprovado',
    PENDENTE = 'Pendente'
}

export type Aprovacao = {
    CodCliente: number
    Nome: string
    Papel: string
    Data: string
    DataMandatoIni: string
    DataMandatoFim: string
    Status: StatusAprovacao
    Ressalva: string
}

export type IncluirAprovacaoRequest = {
    CodCondominio: number
    Ano: number
    Mes: number
    Status: StatusAprovacao
    Ressalva: string
}

export type ListaAprovacaoRequest = {
    CodCondominio: number
    Ano: number
    Mes: number
}

export type ListaAprovacaoResponse = Aprovacao[]

export interface AprovacaoRepository {
    incluir(data: IncluirAprovacaoRequest): Promise<void>
    lista(data: ListaAprovacaoRequest): Promise<ListaAprovacaoResponse>
}

export class ApiAprovacaoRepository implements AprovacaoRepository {
    async incluir(data: IncluirAprovacaoRequest): Promise<void> {
        await api.post<{ success: boolean, message: string }>(`/condominios/${data.CodCondominio}/livro-digital/aprovacoes/incluir`, data)
    }
    async lista(request: ListaAprovacaoRequest): Promise<ListaAprovacaoResponse> {
        const { data } = await api.get<ListaAprovacaoResponse>(`/condominios/${request.CodCondominio}/livro-digital/aprovacoes/lista`, {
            params: {
                ...request
            }
        })

        return data
    }

}

export const aprovacao_repository = new ApiAprovacaoRepository()